<template>
  <li class="breadcrumb-item">
    <icon
      v-if="icon"
      :name="icon"
      color="secondary"
      class="crumb"
      :title="label"
      @click="crumbClicked"
    />
    <span v-else class="crumb emphasis" :title="label" @click="crumbClicked">{{
      collapsed ? "..." : label
    }}</span>
  </li>
</template>
<script>
const crumbClicked = function () {
  this.$emit("crumb-click", this.index);
};

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: " ",
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    crumbClicked,
  },
  emits: ["crumb-click"],
};
</script>
<style lang="scss" scoped>
@import "@/_css/base/_typography";
@import "@/_css/variables";

li {
  display: inline;
  font-size: $text-xs;
  color: $secondary;

  & :hover {
    color: $gray-800;
  }

  & + li:before {
    padding: 0;
    color: black;
    content: "\00a0/\00a0";
  }

  & > .crumb {
    cursor: pointer;
  }
}
</style>
